/**
 * availableKey — single source of truth for the `availableDates` cache key.
 *
 * AK-195: the key MUST include the active season so that switching the season
 * year refetches (and caches) dates per season instead of reusing the previous
 * year's set. Both the writer (`useDatesEffect`) and every reader
 * (`SatelliteStrip`) build the key through this helper so the format can never
 * drift between them.
 *
 * Format: `${scopeType}:${scopeId ?? 'null'}:${product}:${seasonId ?? 'noseason'}`
 */
import type { AvailableKey } from '../state/mapState';

export function availableKey(
  scopeType: string,
  scopeId: string | null | undefined,
  product: string,
  seasonId?: string | null,
): AvailableKey {
  return `${scopeType}:${scopeId ?? 'null'}:${product}:${seasonId ?? 'noseason'}`;
}
